module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("课程顾问跟进数据")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("分配名单详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "label-width": 75
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.nickName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickName", $$v)
      },
      expression: "queryParam.nickName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道",
      "label-width": 75
    }
  }, [_c('channel-select', {
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/userList/getAssignDetails",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "medium"
    }
  }, [_vm._v("\n    官网:" + _vm._s(_vm.assignNum.pcNum) + "\n    移动:" + _vm._s(_vm.assignNum.mobileNum) + "\n    在线咨询:" + _vm._s(_vm.assignNum.onlineAskNum) + "\n    来电咨询:" + _vm._s(_vm.assignNum.telAskNum) + "\n    二维码转介绍:" + _vm._s(_vm.assignNum.qrNum) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-454133cf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data/ShowAssignDetail.vue
// module id = 1771
// module chunks = 8